import {useState} from 'react';
import {connect} from 'react-redux';
import {Toast, SvgIcon, Card} from '@shipwell/shipwell-ui';
import {createUPSRegistration} from '../actions/async';
import PageHeader from 'App/common/pageHeader';
import UPSRegistrationForm from 'App/formComponents/forms/upsRegistration';
import {unpackErrors, cleanPayload} from 'App/utils/globals';
import './styles.scss';
import {useGetUpsQuery} from 'App/containers/ups/hook/ups-hook';

/**
 * UPS Registration Container
 * @param {*} props
 */
const UPSRegistration = (props) => {
  const {isUPSEnabled, dispatch, router, company} = props;
  const [submitError, setSubmitError] = useState(null);
  const [isUpsAuthenticated, setUpsAuthenticated] = useState(false);

  const handleCancel = () => {
    router.push('/carriers/search');
  };

  /**
   * Submit UPS Account Form
   * @param {Object} values
   * @param {Object} actions
   */
  const handleSubmit = async (values, {setSubmitting, setErrors}) => {
    try {
      await dispatch(createUPSRegistration(values.account_number, cleanPayload(values)));
      router.push('/carriers?page=1&q=ups&upsRegistrationSuccess');
    } catch (error) {
      if (error && error.error_description) {
        setSubmitError(error.error_description);
      }
      if (error && error.field_errors) {
        setErrors(unpackErrors(error.field_errors, {}));
      }
    }
    setSubmitting(false);
  };

  useGetUpsQuery({
    onSuccess: (data) => {
      if (data.body.results.filter((result) => result.company.includes(company?.id))[0]) {
        setUpsAuthenticated(Boolean(true));
      }
    },
    onError: (error) => {
      console.error(error);
    }
  });

  return (
    <div className="ups-registration-wrapper">
      <PageHeader title="UPS Registration" />
      <div className="ups-registration-container">
        {isUpsAuthenticated ? (
          <div className="m-auto my-0 w-full max-w-5xl px-5 pt-5 pb-24">
            <Card title="UPS" draggableProvided={'false'}>
              <div className="px-5 py-2.5">
                You are connected with UPS.
                <br />
                <br />
                <div className="w-24">
                  <span className="float-right mt-1 text-sw-success">Connected</span>
                  <span className="left">
                    <SvgIcon name="CheckCircleFilled" color="$sw-success" />
                  </span>
                </div>
              </div>
            </Card>
          </div>
        ) : null}

        {!isUpsAuthenticated && isUPSEnabled && (
          <>
            <p>
              To add UPS parcel support in your Shipwell platform, enter the information below that you used to register
              your UPS account or sign up for an account at{' '}
              <a href="https://www.ups.com" target="_blank" rel="noreferrer">
                ups.com
              </a>
              .
            </p>
            <UPSRegistrationForm onCancel={handleCancel} onSubmit={handleSubmit} />
          </>
        )}
        {!isUPSEnabled && <p className="text-center">You don't have access to this integration.</p>}
        <Toast
          show={Boolean(submitError)}
          title="Error"
          variant="error"
          anchor="bottom-right"
          delay={null}
          onClose={() => setSubmitError(null)}
        >
          {submitError}
        </Toast>
      </div>
    </div>
  );
};

export default connect((state) => ({
  isUPSEnabled: state.company.company.feature_flags && state.company.company.feature_flags.ups_enabled
}))(UPSRegistration);
